// import React from 'react';

// const Header = () => (
//   <header className="bg-white shadow-md sticky top-0 z-50">
//     <div className="container mx-auto flex justify-between items-center p-4">
//       <h1 className="text-xl font-bold text-blue-800">Systematic Career Planner</h1>
//       <nav>
//         <ul className="flex gap-6">
//           <li><a href="#services" className="hover:text-blue-600">Services</a></li>
//           <li><a href="#why" className="hover:text-blue-600">Why Us</a></li>
//           <li><a href="#process" className="hover:text-blue-600">Process</a></li>
//           <li><a href="#contact" className="hover:text-blue-600">Contact</a></li>
//         </ul>
//       </nav>
//     </div>
//   </header>
// );

// export default Header;
import React, { useState } from "react";
import QuizModal from "./QuizModel";
// import Roadmap from "./RoadMap.jsx";

export default function Header({ onQuizComplete }) {
  const [openQuiz, setOpenQuiz] = useState(false);
  // const [quizAnswers, setQuizAnswers] = useState(null);
  return (
    // <header className="sticky top-0 z-20 bg-brand-400/95 backdrop-blur text-white shadow-soft">
    //   <div className="mx-auto max-w-7xl px-4 py-3 flex items-center justify-between">
    //     <a href="/" className="text-lg md:text-xl font-semibold tracking-tight">
    //       Systematic Career Planner
    //     </a>

    //     <nav className="hidden md:flex items-center gap-6 text-sm">
    //       <a className="opacity-90 hover:opacity-100" href="#services">Services</a>
    //       <a className="opacity-90 hover:opacity-100" href="#about">About</a>
    //       <a className="opacity-90 hover:opacity-100" href="#contact">Contact</a>
    //     </nav>

    //     <a
    //       href="#contact"
    //       // className="ml-4 inline-flex items-center rounded-xl2 bg-white px-4 py-2 text-brand-700 shadow-soft hover:scale-[1.02] transition focus-ring"
    //       className="px-6 py-3 rounded-full bg-gradient-to-r from-pink-500 to-yellow-400 text-white shadow-[0_0_20px_rgba(255,0,150,0.6)] hover:shadow-[0_0_40px_rgba(255,0,150,0.8)] transition"
    //     >
    //       Start Now
    //     </a>
    //   </div>
    // </header>
     <header className="fixed w-full top-0 left-0 z-50 backdrop-blur-md bg-white/20 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <h1 className="text-2xl font-extrabold text-white drop-shadow-md tracking-wide">
          <span className="bg-gradient-to-r from-pink-400 via-purple-500 to-yellow-400 bg-clip-text text-transparent animate-gradient">
            Systematic Career Planner
          </span>
        </h1>

        <nav className="hidden md:flex gap-8 text-lg font-medium">
          <a href="#services" className="text-grey hover:font-semibold transition-colors">Services</a>
          <a href="#process" className="text-gray hover:font-semibold transition-colors">Career Stages</a>
          <a href="#about" className="text-gray hover:font-semibold transition-colors">About</a>
          <a href="#contact" className="text-gray hover:font-semibold transition-colors">Contact</a>
        </nav>

        <button
          onClick={() => setOpenQuiz(true)}
          className="px-5 py-2 rounded-full bg-gradient-to-r from-pink-500 to-yellow-400 text-white font-semibold shadow-lg hover:scale-105 transition-transform duration-300"
        >
          🚀 Start Now
        </button>
        {/* Quiz Modal */}
      <QuizModal open={openQuiz} onClose={() => setOpenQuiz(false)} 
          onComplete={(answers) => {
            onQuizComplete(answers); // pass answers to parent
            setOpenQuiz(false);
            setTimeout(() => {
              document.getElementById("roadmap")?.scrollIntoView({ behavior: "smooth" });
            }, 300); // scroll after modal closes
          }}
        />

        {/* Personalized Roadmap */}
      {/* {quizAnswers && <Roadmap answers={quizAnswers} />} */}
      </div>
    </header>
  );
}
